export default __webpack_public_path__ + "static/media/waterMark2.c9381a0e.png";